
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageBubbleStyle, IFlexMessageCarousel } from '@/utils/types'
import Carousel from '@/components/common/flex-message/forms/Carousel.vue'
import cloneDeep from 'lodash/cloneDeep'
import Bubble from '@/components/common/flex-message/forms/Bubble.vue'
import Block from '@/components/common/flex-message/forms/Block.vue'
import Text from '@/components/common/flex-message/forms/Text.vue'
import Span from '@/components/common/flex-message/forms/Span.vue'
import Box from '@/components/common/flex-message/forms/Box.vue'
import Filler from '@/components/common/flex-message/forms/Filler.vue'
import Separator from '@/components/common/flex-message/forms/Separator.vue'
import Button from '@/components/common/flex-message/forms/Button.vue'
import Image from '@/components/common/flex-message/forms/Image.vue'
import Icon from '@/components/common/flex-message/forms/Icon.vue'
import Video from '@/components/common/flex-message/forms/Video.vue'

@Options({
  components: { Video, Icon, Image, Button, Separator, Filler, Box, Span, Text, Block, Bubble, Carousel },
  directives: { maska },
  emits: ['update:modelValue', 'update:altText', 'update:validateValue'],
})
export default class FormPanel extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  altText!: string

  @Prop()
  nodePath!: []

  @Prop({ default: '' })
  selectedPath!: string

  @Prop()
  errorPath!: string[]

  @Prop()
  isAdmin!: boolean

  block = ''

  blockStyle: IFlexMessageBubbleStyle = {
    header: {},
    hero: {},
    body: {},
    footer: {},
  }

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  get nodeValue() {
    this.block = ''
    if (this.selectedPath === '') return undefined
    const keys = cloneDeep(this.nodePath)
    const lastKey = keys[keys.length - 1]
    if (this.value.type === 'bubble') {
      if (lastKey === undefined) {
        return this.value
      } else if (!['header', 'hero', 'body', 'footer'].includes(lastKey)) {
        keys.pop()
      }
    } else {
      if (lastKey === 'carousel') {
        return this.value
      } else if (['box', 'image', 'text', 'button', 'filler', 'separator', 'video', 'span', 'icon'].includes(lastKey)) {
        keys.pop()
      }
    }
    if (['header', 'hero', 'body', 'footer'].includes(lastKey)) {
      this.block = lastKey
      if (this.value.type === 'bubble') {
        return this.initBubbleStyles(this.value)
      } else {
        keys.pop()
        const parent = keys.reduce((acc, key) => acc && acc[key], this.value)
        return this.initBubbleStyles(parent)
      }
    }
    console.log(keys.reduce((acc, key) => acc && acc[key], this.value))
    return keys.reduce((acc, key) => acc && acc[key], this.value)
  }

  initBubbleStyles(value: IFlexMessageBubble) {
    value.styles = { ...cloneDeep(this.blockStyle), ...value.styles }
    return value.styles
  }

  async validate() {
    if (this.nodeValue && 'type' in this.nodeValue) {
      return await this.$refs.messageForm.validate()
    }
    return true
  }
}
